import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { MethylationBh4CycleDiagramContent } from "./MethylationBh4CycleDiagram";
import { MethylationBh4CycleKeyContent } from "./MethylationBh4CycleKey";

const SvgMethylationBh4CycleDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1424}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 869, 1119)}
      viewBox={diagramOnly ? "0 176 1424 869" : "0 0 1424 1119"}
    >
      <g id="methylation-bh4cycle-diagram+key" clipPath="url(#clip0_18291_211490)">
        <rect width={1424} height={diagramOnly ? 869 : 1119} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <MethylationBh4CycleKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <MethylationBh4CycleDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18291_211490">
          <rect width={1424} height={1119} fill="white" />
        </clipPath>
        <clipPath id="clip1_18291_211490">
          <rect width={1424} height={869} fill="white" transform="translate(0 176)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgMethylationBh4CycleDiagramKey;
